import { CaretLeft, Wallet } from "@phosphor-icons/react";
import { Icon } from "@phosphor-icons/react";
import { useNavigate } from "react-router-dom";
import { formatAsMoney } from "../../../../helpers/numbers";

interface BillPageHeaderProps {
  title: string;
  subtitle?: string;
  icon: Icon;
  walletBalance: number;
}

/**
 * Compact bills header: back control, title with service icon, and a wallet
 * balance chip. Replaces the oversized hero banners so the actual form sits
 * near the top of the page (especially on mobile).
 */
const BillPageHeader = ({
  title,
  subtitle,
  icon: ServiceIcon,
  walletBalance,
}: BillPageHeaderProps) => {
  const navigate = useNavigate();

  return (
    <div className="flex items-center justify-between gap-4">
      <div className="flex items-center gap-3 min-w-0">
        <button
          type="button"
          onClick={() => navigate(-1)}
          className="p-2.5 rounded-full border border-gray-300 text-deepBlue hover:bg-gray-50 transition shrink-0"
          aria-label="Go back"
        >
          <CaretLeft weight="bold" />
        </button>
        <div className="w-10 h-10 rounded-full bg-visaro-orange/10 text-visaro-orange flex items-center justify-center shrink-0">
          <ServiceIcon size={20} weight="bold" />
        </div>
        <div className="min-w-0">
          <h1 className="font-bold text-lg sm:text-xl text-gray-900 truncate">
            {title}
          </h1>
          {subtitle && (
            <p className="text-xs sm:text-sm text-gray-500 truncate">
              {subtitle}
            </p>
          )}
        </div>
      </div>

      <div className="flex items-center gap-2 rounded-full border border-gray-200 bg-white px-3 py-2 shadow-sm shrink-0">
        <Wallet size={16} weight="bold" className="text-deepBlue" />
        <span className="text-xs sm:text-sm font-semibold text-gray-900 whitespace-nowrap">
          NGN {formatAsMoney(walletBalance || 0)}
        </span>
      </div>
    </div>
  );
};

export default BillPageHeader;
